"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Store_1 = require("owa-mail-list-store/lib/store/Store");
var undoActions = require("owa-mail-undo");
var legacy_1 = require("satcheljs/lib/legacy");
var owa_mail_list_store_1 = require("owa-mail-list-store");
var owa_mail_feature_flags_1 = require("owa-mail-feature-flags");
var owa_analytics_1 = require("owa-analytics");
var owa_mail_inference_tracking_1 = require("owa-mail-inference-tracking");
var datapoints_1 = require("../datapoints");
var deleteItemsStoreUpdate_1 = require("owa-mail-actions/lib/triage/deleteItemsStoreUpdate");
var owa_mail_list_store_2 = require("owa-mail-list-store");
var Store_2 = require("owa-mail-store/lib/store/Store");
var setItemsInferenceClassificationService_1 = require("owa-mail-triage-action/lib/services/setItemsInferenceClassificationService");
/**
 * move to focused/other action
 * @param conversationRowKeys the specified rowKeys
 * @param tableViewId the table view id
 * @param actionSource the source that initiated this action
 * @return the action response
 */
exports.default = legacy_1.action('moveItemsToFocusedOrOther', datapoints_1.default.moveConversationToFocusedOrOther)(function moveItemsToFocusedOrOther(itemRowKeys, tableViewId, actionSource) {
    var tableView = Store_1.default.tableViews.get(tableViewId);
    var focusedViewFilter = owa_mail_list_store_1.getFocusedFilterForTable(tableView);
    var isFocusedView = focusedViewFilter == 0 /* Focused */;
    var itemIdStrings = owa_mail_list_store_2.getRowIdsFromRowKeys(itemRowKeys, tableViewId);
    undoActions.clearLastUndoableAction();
    var itemContexts = itemIdStrings.map(function (itemIdValue) {
        var item = Store_2.default.items.get(itemIdValue);
        var isReadValue;
        if (owa_mail_list_store_1.isItemOfMessageType(item)) {
            isReadValue = item.IsRead;
        }
        else {
            // Default to isRead = true when not a mail item
            isReadValue = true;
        }
        return {
            itemId: itemIdValue,
            conversationId: item.ConversationId.Id,
            isRead: isReadValue,
        };
    });
    setItemsInferenceClassificationService_1.default(itemIdStrings, isFocusedView ? 'Other' : 'Focused');
    // Dispatch action to update the store state
    deleteItemsStoreUpdate_1.default(itemContexts, tableView.tableQuery.folderId);
    if (owa_mail_feature_flags_1.isMailFeatureEnabled('tri-nonSubstrateInference')) {
        var activityTime_1 = new Date().toISOString();
        owa_mail_inference_tracking_1.lazyBuildInferenceDatapoint.import().then(function (buildInferenceDatapoint) {
            owa_analytics_1.lazyLogCustomDataLoggerDatapoint.importAndExecute(buildInferenceDatapoint(tableView.serverFolderId, focusedViewFilter, activityTime_1, isFocusedView ? "MarkAsOther" /* MarkAsOther */ : "MarkAsFocused" /* MarkAsFocused */, itemIdStrings));
        });
    }
});
//# sourceMappingURL=moveItemsToFocusedOrOther.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/items/moveItemsToFocusedOrOther.js
// module id = 5626
// module chunks = 62